import { Controller } from '@hotwired/stimulus'

import PhotoSwipe from 'photoswipe'
import PhotoSwipeLightbox from 'photoswipe/lightbox'

export default class extends Controller {
  static targets = ['image']

  connect () {
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.element,
      children: '[data-lightbox-target="image"]',
      wheelToZoom: true,
      pswpModule: PhotoSwipe
    })
    this.lightbox.init()
  }

  disconnect () {
    this.lightbox.destroy()
  }
}
